import React, { createContext, useContext, useState } from 'react';

interface AiChatContextType {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    toggleChat: () => void;
}

const AiChatContext = createContext<AiChatContextType | undefined>(undefined);

export const AiChatProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleChat = () => setIsOpen((prev) => !prev);

    return (
        <AiChatContext.Provider value={{ isOpen, setIsOpen, toggleChat }}>
            {children}
        </AiChatContext.Provider>
    );
};

export const useAiChat = () => {
    const context = useContext(AiChatContext);
    if (context === undefined) {
        throw new Error('useAiChat must be used within an AiChatProvider');
    }
    return context;
};
